import { CContainer } from '@coreui/react'
import React from 'react'
// import logo from '../../../../assets/images/logo-d3-v2.png'

const Header = () => {
    return (
        <div>
            <CContainer>
                <img src={require('../../../../assets/images/logo-d3-v2.png')} alt='دفتر شما' />

            </CContainer>
        </div>
    )
}

export default Header